import styled from "styled-components"
import { Link } from "react-router-dom"
import EIPLogo from "../assets/logos/eip-logo-white.png"
import Image1 from "../assets/images/image-1.jpg"
import Image2 from "../assets/images/image-2.jpg"
import Image3 from "../assets/images/image-3.jpg"
import Image4 from "../assets/images/image-4.jpg"
import { phoneWidth } from "../Globalstyle"

const Header = styled.div`
  height: 7rem;
  padding: 2rem var(--side-padding);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${phoneWidth}) {
    /* flex-direction: column; */
    padding: 2rem 1rem;
  }
`

const LogoContainer = styled.span`
  display: inline-block;
  height: 100%;
  cursor: pointer;

  @media (max-width: ${phoneWidth}) {
    height: 3rem;
  }
`

const Logo = styled.img`
  height: 100%;
`

const Links = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

const LinkButton = styled(Link)`
  text-decoration: none;
  color: black;
  background-color: white;
  padding: 0.5rem 1rem;
`

const InfoBox = styled.div`
  padding: var(--side-padding);
  padding-right: 0;
  display: grid;
  grid-template-columns: 3fr 2fr;
  column-gap: 2rem;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
    padding-right: var(--side-padding);
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const HeroImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

const HeroImage = styled.img`
  width: 100%;
  object-fit: cover;
`

const Title = styled.div`
  font-size: 5rem;
  font-weight: bold;
  line-height: 4.25rem;
`

const Description = styled.p`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const ImageRow = styled.div`
  height: 25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: ${phoneWidth}) {
    flex-direction: column;
    height: auto;
  }
`

const ImageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${phoneWidth}) {
    height: 50rem;
    width: 100%;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 0;
`

const Banner = () => {
  return (
    <div>
      <Header>
        <LogoContainer>
          <Logo src={EIPLogo} alt="Logo"/>
        </LogoContainer>
        <Links>
          <LinkButton to="/">Sylhet Relief</LinkButton>
          <LinkButton to="/donate">Donate</LinkButton>
        </Links>
      </Header>
      <InfoBox>
        <Text>
          <Title>
            Earth <span style={{color: "var(--yellow)"}}>Identity</span> Project
          </Title>
          <Description>
            Initially registered as Kerara Nokai, The Earth Identity Project started as a Japanese NGO 
            in 1993, its humble beginning earning the enterprise just a small office based in Rajarhat, 
            Kurigram. In 1999, at the request of the Japanese Executive Committee, Kerera Nokai was 
            renamed 'Earth Identity Project' and Mrs. Nasrine Karim was appointed its Executive Director.
          </Description>
        </Text>
        <HeroImageContainer>
          <HeroImage src={Image1} alt="Earth Identity Project"/>
        </HeroImageContainer>
      </InfoBox>
      <ImageRow>
        <ImageContainer>
          <Image src={Image2} alt="Earth Identity Project"/>
        </ImageContainer>
        <ImageContainer>
          <Image src={Image3} alt="Earth Identity Project"/>
        </ImageContainer>
        <ImageContainer>
          <Image src={Image4} alt="Earth Identity Project"/>
        </ImageContainer>
      </ImageRow>
    </div>
  )
}

export default Banner